import React from "react";

export default function AdminPageHeader({ icon: Icon, title, description, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-7">
      <div className="flex items-start gap-3 min-w-0">
        {Icon && (
          <div className="w-9 h-9 shrink-0 rounded-md bg-[rgba(58,0,224,0.07)] flex items-center justify-center">
            <Icon className="h-4 w-4 text-[#3a00e0]" />
          </div>
        )}
        <div className="min-w-0">
          <h1 className="text-[1.35rem] font-semibold text-slate-900 tracking-tight">{title}</h1>
          <span className="section-title-rule" aria-hidden="true" />
          {description && <p className="text-slate-500 text-sm -mt-1 leading-relaxed">{description}</p>}
        </div>
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
